import { P2TextDescription } from "react-bootstrap-common-script";
import { useAppSelector } from "../../redux/hook";
import { OwnershipReasonEnum } from "../../models/enum/ownership-reason.enum";
import { ChangeOwnershipReasonCode } from "../../utils/code-converter";
import QuestionAnswer from "./question-answer";
import { useMemo } from "react";
import { ReasonEnum } from "../../models/enum/reason.enum";
import { capitalize } from "lodash";
import moment from "moment";
import {
  Radio_Cpf_Refund,
  Radio_Submit_Consent,
} from "../../utils/shared-radio";
import { DemiseCurrentOwner } from "../../utils/shared-dropdown";

function ReviewEligibility() {
  const applicationStep1FormData = useAppSelector(
    (state) => state.app.ApplicationStep1Slice.formData
  );
  const changeOwnerShipReasonObject = useMemo(() => {
    return ChangeOwnershipReasonCode.find(
      (item) =>
        item.change_ownership_reason_value ===
        applicationStep1FormData.reason.change_ownership_reason
    );
  }, [applicationStep1FormData]);
  return (
    <div style={{ padding: 24 }}>
      <P2TextDescription required color="#000" title="Eligibility" />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 32,
          marginTop: 32,
        }}
      >
        <QuestionAnswer
          question={"Reason for change of ownership"}
          answer={changeOwnerShipReasonObject?.label ?? ""}
        />
        {(changeOwnerShipReasonObject?.reason_value ===
          ReasonEnum.marital_status_reason_value ||
          changeOwnerShipReasonObject?.reason_value ===
            ReasonEnum.owner_moving_out_reason_value) && (
          <QuestionAnswer
            question={"Which of the following best describes your situation?"}
            answer={changeOwnerShipReasonObject?.hdb_description ?? ""}
          />
        )}
        {changeOwnerShipReasonObject?.change_ownership_reason_value ===
          OwnershipReasonEnum.divorce && (
          <>
            <QuestionAnswer
              question={
                "Have you obtained the Certificate of Final Judgement or Divorce Certificate?"
              }
              answer={
                applicationStep1FormData.reason.have_final_judgement
                  ? capitalize(
                      applicationStep1FormData.reason.have_final_judgement
                    )
                  : "-"
              }
            />
            {applicationStep1FormData.reason.have_final_judgement === "yes" && (
              <>
                <QuestionAnswer
                  question={
                    "Please indicate the Final Judgement/ Certificate of Divorce date"
                  }
                  answer={
                    applicationStep1FormData.reason.final_judgement_date
                      ? moment(
                          applicationStep1FormData.reason.final_judgement_date
                        ).format("DD MMMM YYYY")
                      : "-"
                  }
                />
                <QuestionAnswer
                  question={
                    "Please indicate the due date to complete the ownership change as shown in the Court Order."
                  }
                  answer={
                    applicationStep1FormData.reason.date_of_court_order
                      ? moment(
                          applicationStep1FormData.reason.date_of_court_order
                        ).format("DD MMMM YYYY")
                      : "-"
                  }
                />
                <QuestionAnswer
                  question={
                    "Please indicate the cash consideration amount stated in the Court Order."
                  }
                  answer={
                    applicationStep1FormData.reason.amount_stated_in_court_order
                      ? `SGD$${applicationStep1FormData.reason.amount_stated_in_court_order}`
                      : "-"
                  }
                />
                <QuestionAnswer
                  question={"Amount of CPF refund to outgoing owner:"}
                  answer={
                    applicationStep1FormData.reason.cpf_refund
                      ? Radio_Cpf_Refund.find(
                          (item) =>
                            item.value ===
                            applicationStep1FormData.reason.cpf_refund
                        )?.description?.toString()!
                      : "-"
                  }
                />
                <QuestionAnswer
                  question={
                    "I confirm that all current and proposed owners are willing to log in via SingPass to submit their consent for this application, and attend the completion appointment in person."
                  }
                  answer={
                    typeof applicationStep1FormData.reason.submit_content ===
                    "boolean"
                      ? Radio_Submit_Consent.find(
                          (item) =>
                            item.value ===
                            applicationStep1FormData.reason.submit_content
                        )?.description?.toString()!
                      : "-"
                  }
                />
              </>
            )}
          </>
        )}
        {(changeOwnerShipReasonObject?.change_ownership_reason_value ===
          OwnershipReasonEnum.inclusion_due_to_marriage ||
          changeOwnerShipReasonObject?.change_ownership_reason_value ===
            OwnershipReasonEnum.moving_out_due_to_marriage) && (
          <QuestionAnswer
            question={"Please indicate the date of marriage"}
            answer={
              applicationStep1FormData.reason.date_of_marriage
                ? moment(
                    applicationStep1FormData.reason.date_of_marriage
                  ).format("DD MMMM YYYY")
                : "-"
            }
          />
        )}
        {changeOwnerShipReasonObject?.change_ownership_reason_value ===
          OwnershipReasonEnum.financial_difficulties && (
          <>
            <QuestionAnswer
              question={
                "Do you currently have any outstanding loan or outstanding upgrading costs?"
              }
              answer={
                applicationStep1FormData.reason.has_outstanding_loan
                  ? capitalize(
                      applicationStep1FormData.reason.has_outstanding_loan
                    )
                  : "-"
              }
            />
            {applicationStep1FormData.reason.has_outstanding_loan === "yes" && (
              <>
                <QuestionAnswer
                  question={"Please indicate your outstanding loan amount?"}
                  answer={
                    applicationStep1FormData.reason.outstanding_loan_amount
                      ?.length > 0
                      ? `SGD$${applicationStep1FormData.reason.outstanding_loan_amount}`
                      : "-"
                  }
                />
              </>
            )}
          </>
        )}
        {changeOwnerShipReasonObject?.change_ownership_reason_value ===
          OwnershipReasonEnum.demise_of_current_owner && (
          <>
            {applicationStep1FormData.reason.has_administration_items && (
              <QuestionAnswer
                question={"Do you have the following documents?"}
                answer={
                  DemiseCurrentOwner.dropdownSelection
                    .find(
                      (item) =>
                        item.value ===
                        applicationStep1FormData.reason.has_administration_items
                    )
                    ?.description?.toString() ?? "-"
                }
              />
            )}
            {applicationStep1FormData.reason.death_date && (
              <QuestionAnswer
                question={"Please indicate the date of death"}
                answer={moment(
                  applicationStep1FormData.reason.death_date
                ).format("DD MMMM YYYY")}
              />
            )}
            {applicationStep1FormData.reason.is_beneficiary_proposed_owners && (
              <QuestionAnswer
                question={
                  "Are all the beneficiaries listed in the Will or Intestate Succession Act also the proposed owners?"
                }
                answer={
                  DemiseCurrentOwner.beneficiariesProposedOwners
                    .find(
                      (item) =>
                        item.value ===
                        applicationStep1FormData.reason
                          .is_beneficiary_proposed_owners
                    )
                    ?.description?.toString() ?? "-"
                }
              />
            )}
          </>
        )}
        {changeOwnerShipReasonObject?.change_ownership_reason_value ===
          OwnershipReasonEnum.renunciation && (
          <QuestionAnswer
            question={
              "Please indicate the date of renunciation of SC/SPR status"
            }
            answer={
              applicationStep1FormData.reason.date_of_renunciation
                ? moment(
                    applicationStep1FormData.reason.date_of_renunciation
                  ).format("DD MMMM YYYY")
                : "-"
            }
          />
        )}
      </div>
    </div>
  );
}

export default ReviewEligibility;